import { render } from "./OrderHistoryPanel.vue?vue&type=template&id=280363dd&scoped=true&ts=true"
import script from "./OrderHistoryPanel.vue?vue&type=script&lang=ts"
export * from "./OrderHistoryPanel.vue?vue&type=script&lang=ts"

import "./OrderHistoryPanel.vue?vue&type=style&index=0&id=280363dd&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-280363dd"]])

export default __exports__